import { ArrowRight, BookOpen, CalendarHeart, Library, PenLine } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const EVENTS = [
  {
    icon: BookOpen,
    title: "School author visits",
    body: "Interactive storytelling, creative workshops and Team Bailey certificates — a day pupils remember.",
  },
  {
    icon: Library,
    title: "Library readings",
    body: "Storytime sessions at local libraries, with colouring, questions and plenty of giggles.",
  },
  {
    icon: PenLine,
    title: "Book signings",
    body: "Meet Damali, get your books signed and take home a photo with Bailey's creator.",
  },
  {
    icon: CalendarHeart,
    title: "Festivals & family days",
    body: "Find the Bailey stand at literary festivals and community family events across the UK.",
  },
];

export default function Events() {
  const scrollToForm = () => {
    const el = document.getElementById("schools");
    if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -70 }) : el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="events" data-testid="events-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <Eyebrow className="mb-4">Author events</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-walnut mb-5">
              Meet Damali in person
            </h2>
            <p className="text-sm sm:text-base text-walnutsoft leading-relaxed max-w-lg mb-10">
              From classrooms to libraries to festival stages, Damali brings Bailey's
              world to life at live events across the UK. Hosting an event? She'd love
              to hear from you.
            </p>
          </Reveal>
          <div className="grid sm:grid-cols-2 gap-4 mb-10">
            {EVENTS.map((e, i) => (
              <Reveal key={e.title} delay={i * 0.08}>
                <div
                  data-testid={`event-type-${e.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="h-full rounded-3xl border border-sand bg-white/70 p-6 hover:-translate-y-1 hover:shadow-[0_20px_36px_-20px_rgba(49,67,92,0.3)] transition-all duration-300"
                >
                  <span className="inline-flex w-11 h-11 rounded-2xl bg-sage/15 items-center justify-center mb-4">
                    <e.icon size={19} className="text-sage" />
                  </span>
                  <h3 className="font-display font-bold text-base sm:text-lg tracking-tight text-walnut mb-1.5">{e.title}</h3>
                  <p className="text-sm text-walnutsoft leading-relaxed">{e.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <button
              data-testid="events-enquiry-button"
              onClick={scrollToForm}
              className="group rounded-full bg-terracotta text-cream pl-7 pr-6 py-4 font-display font-bold text-sm sm:text-base inline-flex items-center gap-2 hover:bg-terracottadark transition-colors shadow-[0_18px_36px_-14px_rgba(79,163,227,0.6)]"
            >
              Invite Damali to your event
              <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="rounded-[2rem] overflow-hidden border border-sand spotlight p-6">
              <img
                src="/images/damali-author.webp"
                alt="Damali Allison at a library author event, holding Bailey, What Can You Do?"
                loading="lazy"
                className="w-full aspect-[4/5] object-cover rounded-2xl shadow-[0_30px_60px_-24px_rgba(49,67,92,0.45)] hover:scale-[1.02] transition-transform duration-700"
              />
            </div>
            <div className="absolute -bottom-6 -right-3 sm:-right-6 bg-terracotta text-cream rounded-2xl px-6 py-4 shadow-xl rotate-[2deg]">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] opacity-80 mb-1">Live & in person</p>
              <p className="font-display font-bold text-base leading-tight">Storytime with<br />Damali Allison</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
